import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  lot: {},
  paymentSuccess: null,
  errorPaymentMessage: null
}

const mutations = {
  SET_LOT (state, payload) {
    state.lot = payload
  },
  SET_PAYMENT_SUCCESS (state, payload) {
    state.paymentSuccess = payload
  },
  SET_ERROR_PAYMENT_MESSAGE (state, payload) {
    state.errorPaymentMessage = payload
  },
  SET_HIDE_MODAL (state) {
    state.paymentSuccess = null
    state.errorPaymentMessage = null
  },
  PAYMENT () {}
}

const actions = {
  async loadReservingLot ({ commit }, id) {
    app.$Progress.start()

    try {
      const response = await axios.get(`sales/reservation/${id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit(
          'SET_ALERT_MESSAGE',
          {
            color: 'danger',
            title: 'errors.connection_error',
            text: checkErrors.message
          },
          { root: true }
        )
      } else {
        commit('SET_LOT', response.data)
        // commit("SET_MODAL_VISIBLE", false);
        commit('SET_ACCEPT_ALERT', {}, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit(
        'SET_ALERT_MESSAGE',
        {
          color: 'danger',
          title: 'errors.connection_error',
          text: 'errors.generic_error'
        },
        { root: true }
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async payment ({ commit }, payload) {
    app.$Progress.start()

    try {
      const response = await axios.post(`payment`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_PAYMENT_SUCCESS', false)
        commit(
          'SET_ERROR_PAYMENT_MESSAGE',
          'Tu pago no pudo ser procesado'
        )
      } else {
        commit('SET_PAYMENT_SUCCESS', true)
        commit(
          'SET_ACCEPT_ALERT',
          {
            color: 'success',
            title: 'strings.sales',
            text: 'front.sale_seccesfully',
            icon: 'checkmark-circle-outline'
          },
          { root: true }
        )
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_PAYMENT_SUCCESS', false)
      commit(
        'SET_ERROR_PAYMENT_MESSAGE',
        'Tu pago no pudo ser procesado'
      )
    } finally {
      app.$Progress.finish()
    }
  },
  async showError ({ commit }, payload) {
    commit(
      'SET_ALERT_MESSAGE',
      {
        color: 'danger',
        title: 'errors.transaction_error',
        text: payload.message
      },
      { root: true }
    )
  },
  hideModal ({ commit }) {
    commit('SET_HIDE_MODAL')
  }
}

const getters = {
  lot: state => state.lot,
  paymentSuccess: state => state.paymentSuccess,
  errorPaymentMessage: state => state.errorPaymentMessage
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
